module.exports = __webpack_public_path__ + "static/media/compliance_subbanner1.ebb574de.webp";